/* @ngInject */
const data = () => {
  const self = {}

  return self
}

export default data



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/commande/services/data.service.js